import { hasReportsAccess } from '../../utils'

// Where clicking a tag chip takes the user: Reports when they have access to
// it, otherwise their own Vouchers list. Both pages read `?tag=<id>`.
export const tagListPath = (tagId: number, authUser: any): string => {
  const base = hasReportsAccess(
    authUser?.branch,
    authUser?.department?.name,
    authUser?.user_role?.code,
  )
    ? '/panel/reports'
    : '/panel/vouchers'
  return `${base}?tag=${tagId}`
}

/** The `?tag=<id>` a tag chip link put in the URL, if any. */
export const tagIdFromSearch = (search: string): number | null => {
  const raw = new URLSearchParams(search).get('tag')
  const id = raw ? parseInt(raw, 10) : NaN
  return Number.isFinite(id) ? id : null
}
